import { FaultCategory, type FaultData, OtherFaultType, RelatedEntityType, type VisitFaultModel } from '../models';

const conditionalSeparator = (result: string) => {
  if (result.length) return ' - ';
  return '';
};

export const composeVisitFaultName = (visitFault: VisitFaultModel | FaultData): string => {
  const { category, type, subType, customName, relatedEntityType, relatedEntityName } = visitFault;
  let result: string = '';

  // If Technical Fault
  if (category === FaultCategory.Technical) {
    if (relatedEntityType) {
      // If Related = Other
      //    => append customName (if any)
      if (relatedEntityType === RelatedEntityType.Other) {
        if (customName) result += `${conditionalSeparator(result)}${customName}`;
      } else {
        // If Related != Other
        if (type === OtherFaultType.Other) {
          // If type = Other => append customName (if any)
          if (customName) result += `${conditionalSeparator(result)}${customName}`;
        } else {
          // If type != Other
          //    => append type (if any)
          if (type) result += `${conditionalSeparator(result)}${type}`;
          //    => append subType (if any)
          if (subType) result += `${conditionalSeparator(result)}${subType}`;
        }
        // => append relatedEntityType
        result += `${conditionalSeparator(result)}${relatedEntityType}`;
        // => append relatedEntityName (if any)
        if (relatedEntityName) result += `${conditionalSeparator(result)}${relatedEntityName}`;
      }
    }
  } else {
    // If Operational Fault
    if (type === OtherFaultType.Other) {
      // If type = Other => append customName (if any)
      if (customName) result += `${conditionalSeparator(result)}${customName}`;
    } else {
      // If type != Other
      //    => append type (if any)
      if (type) result += `${conditionalSeparator(result)}${type}`;
      //    => append subType (if any)
      if (subType) result += `${conditionalSeparator(result)}${subType}`;
    }
  }

  return result;
};
